import React from 'react';
import { Card, Empty, Timeline, Typography } from 'antd';
import type { CatalogStats } from './useIntegrationDetail';

const { Text, Title, Paragraph } = Typography;

type Props = {
  marketplace: string;
  lastCatalogSyncedAt?: string | null;
  warehousesUpdatedAt?: string | null;
  catalogStats?: CatalogStats | null;
};

function formatWhen(iso?: string | null) {
  if (!iso) return null;
  try {
    return new Date(iso).toLocaleString('ru', {
      day: 'numeric',
      month: 'long',
      hour: '2-digit',
      minute: '2-digit',
    });
  } catch {
    return iso;
  }
}

export const SyncJournalTab = ({
  marketplace,
  lastCatalogSyncedAt,
  warehousesUpdatedAt,
  catalogStats,
}: Props) => {
  const items = [
    lastCatalogSyncedAt
      ? {
          color: 'green' as const,
          children: (
            <div>
              <Text strong>Каталог товаров синхронизирован</Text>
              <div>
                <Text type="secondary">{formatWhen(lastCatalogSyncedAt)}</Text>
              </div>
              {catalogStats ? (
                <div>
                  <Text type="secondary">
                    Всего {catalogStats.total}, без связи {catalogStats.unlinked}
                  </Text>
                </div>
              ) : null}
            </div>
          ),
        }
      : null,
    warehousesUpdatedAt
      ? {
          color: 'blue' as const,
          children: (
            <div>
              <Text strong>Состояния складов обновлены</Text>
              <div>
                <Text type="secondary">{formatWhen(warehousesUpdatedAt)}</Text>
              </div>
            </div>
          ),
        }
      : null,
  ].filter(Boolean) as { color: 'green' | 'blue'; children: React.ReactNode }[];

  return (
    <Card
      bordered={false}
      style={{ borderRadius: 8, boxShadow: '0 1px 2px rgba(0,0,0,0.04)' }}
    >
      <Title level={5} style={{ marginTop: 0 }}>
        Журнал синхронизации
      </Title>
      <Paragraph type="secondary">
        Краткая сводка по последним операциям для {marketplace}. Полная история
        задач — в разделе «Запуск задач».
      </Paragraph>
      {items.length === 0 ? (
        <Empty
          image={Empty.PRESENTED_IMAGE_SIMPLE}
          description="Пока нет зафиксированных синхронизаций"
        />
      ) : (
        <Timeline items={items} />
      )}
    </Card>
  );
};
